import {FilterStore} from 'app/store/filters/FilterStore';
import GameInterface from 'app/interfaces/GameInterface';
import {prepareFiltersQuery} from 'app/utils/prepareFiltersQuery';
import {makeObservable, override} from 'mobx';
import getCookies from 'app/utils/getCookies';

export class QuickBetsFilterStore extends FilterStore {
    constructor(games: GameInterface[]) {
        super('q', games);
        this.appliedFilters = getCookies(`${this.filterType}Filters`, []);
        makeObservable(this);
    }

    @override
    get queryNavigateParams(): Record<string, string> {
        const filters = prepareFiltersQuery(this.filters);

        return {
            q24h: this.only24h.toString(),
            qDisc: this.discipline,
            qEvent: this.currentEvents,
            qSport: filters,
            qType: this.betType,
            qUp: this.onlyUpcomingMatches.toString()
        };
    }
}
